import map from 'lodash/map'
import React from 'react'

import { Wordbook } from '@Components/Wordbook'
import { AccordionItem } from '@CoreComponents/Accordions/HeaderWithAccordion'
import { ProductSizeGuideContentFragment } from '@Generated/graphql'

import styles from './SizeTable.module.scss'

export const SizeTable = ({
  items,
}: {
  items: ProductSizeGuideContentFragment['sizeGuideItems']
}) => {
  if (!items || items.length === 0) {
    return null
  }

  return (
    <>
      {map(items, item => (
        <AccordionItem
          key={item.id || ''}
          className={styles.accordion}
          header={<Wordbook wordbook={item.title} />}
          id={item.id || ''}
        >
          <table className={styles.sizeTable}>
            {item.headers && item.headers.length !== 0 && (
              <thead>
                <tr>
                  {item.headers.map(header => (
                    // eslint-disable-next-line jsx-a11y/control-has-associated-label
                    <th key={header.id || ''}>
                      <Wordbook wordbook={header.text} />
                    </th>
                  ))}
                </tr>
              </thead>
            )}
            <tbody>
              {map(item.rows, row => (
                <tr key={row.id || ''}>
                  {row.columns?.map((column) => {
                    const Element = column?.isHeader ? 'th' : 'td'

                    return (
                      <Element key={column.id || ''}>
                        <Wordbook wordbook={column.text} />
                      </Element>
                    )
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </AccordionItem>
      ))}
    </>
  )
}
